import { Injectable } from '@angular/core';

export function clearAndUpper(text: string) {
    return text.replace(/-/, "").toUpperCase();
}

export function toPascalCase(text: string) {
    return text.replace(/(^\w|-\w)/g, clearAndUpper);
}

@Injectable({
    providedIn: 'root'
})
export class UtilsService {

}